import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Brand } from '@app/shared/models/brand';
import { CountryService } from '@app/shared/services/country.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectionModel } from '@angular/cdk/collections';
import { FacebookPageSummaryModel } from '@app/modules/facebook-pages/models/facebook-page-summary.model';

@Component({
  selector: 'app-social-media-locations',
  templateUrl: './social-media-locations.component.html',
  styleUrl: './social-media-locations.component.scss',
})
export class SocialMediaLocationsComponent implements OnInit {
  constructor(
    private countryService: CountryService,
    private translateService: TranslateService,
    private http: HttpClient
  ) {}

  @Input() activateLocationsLabel =
    this.translateService.instant('GENERAL.CONTINUE');
  @Input() cancelLabel = this.translateService.instant('GENERAL.SKIP_FOR_NOW');
  @Input() activationSource: string = 'facebook';
  @Input() locations: FacebookPageSummaryModel[] = [];
  @Input() isLoading = false;
  @Input() brand?: Brand;

  @Output() activateLocations: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  @Output() skipActivation: EventEmitter<void> = new EventEmitter<void>();

  displayedColumns: string[] = ['select', 'locations'];

  ngOnInit() {
    // Load and merge per-component translation file
    const lang =
      this.translateService.currentLang ||
      this.translateService.getDefaultLang() ||
      'en';
    this.http
      .get(`/assets/locale/${lang}/dashboard.json`)
      .subscribe((translations) => {
        this.translateService.setTranslation(lang, translations, true);
      });
    this.http
      .get(`/assets/locale/${lang}/general.json`)
      .subscribe((translations) => {
        this.translateService.setTranslation(lang, translations, true);
      });
    this.http
      .get(`/assets/locale/${lang}/locations.json`)
      .subscribe((translations) => {
        this.translateService.setTranslation(lang, translations, true);
      });

    // Set initial direction
    this.setDirection(lang);

    // Listen for language changes to update direction
    this.translateService.onLangChange.subscribe((event) => {
      this.setDirection(event.lang);
    });
    this.dataSource.data = this.locations as FacebookPageSummaryModel[];
  }

  dataSource: MatTableDataSource<FacebookPageSummaryModel> =
    new MatTableDataSource<FacebookPageSummaryModel>([]);

  selection: SelectionModel<string> = new SelectionModel<string>(true, []);
  locationsSelectedCount = 0;

  isAllSelected(): boolean {
    return this.dataSource.data.every((data) =>
      this.selection.selected.includes(data.id)
    );
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    const list = this.dataSource.data.map((x) => x.id);
    if (list) {
      this.selection.select(...list);
    }
  }
  skipStep(): void {
    this.skipActivation.emit();
  }

  continue(): void {
    const locationIds = this.selection.selected;
    this.activateLocations.emit(locationIds);
  }

  searchField(event: KeyboardEvent) {
    this.dataSource.data = this.locations;
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    // Collect filtered data
    const filteredData = this.dataSource.filteredData;
    this.dataSource.data = [...filteredData];
  }

  private setDirection(lang: string) {
    if (lang === 'ar') {
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      document.documentElement.setAttribute('dir', 'ltr');
    }
  }
}
